import { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import axiosConfig from "../../../services/Axios";
import Select from "react-select";
import SelectTheme from "./SelectTheme";
import SelectStyle from "./SelectStyle";

const SelectCountries = ({
  onChange,
  cancelToken = null,
  value = null,
  isClearable = true,
  searchable = true,
}) => {
  const [options, setOptions] = useState();
  const [selectedValue, setSelectedValue] = useState(null);
  const { i18n } = useTranslation();

  const fetchCountries = useCallback(async (token) => {
    return await axiosConfig
      .get(process.env.REACT_APP_API_URL + "/api/countries?pagination=false", {
        cancelToken: token,
      })
      .then((response) => {
        let countries = response.data["hydra:member"].map((country) => {
          return {
            value: country.isoCode2,
            label: i18n.language === "fr" ? country.labelFr : country.labelEn,
          };
        });
        countries.sort(function (a, b) {
          return a.label > b.label;
        });
        setOptions(countries);

        if (value || emptyOpt === false) {
          let selected = countries.filter((c) => c.value === value)[0];
          setSelectedValue(selected);
        } else {
          setSelectedValue(null);
        }

        return countries;
      })
      .catch(function (thrown) {
        if (axiosConfig.isCancel(thrown)) {
          console.log("Countries Request canceled : ", thrown.message);
        } else {
          // handle error
        }
      });
  }, []);

  useEffect(() => {
    fetchCountries(cancelToken);
  }, [cancelToken]);

  return (
    <>
      <Select
        styles={SelectStyle}
        isSearchable={searchable}
        isClearable={isClearable}
        options={options}
        value={selectedValue}
        onChange={(e) => {
          onChange(e && e.value !== "" ? e.value : null);
          setSelectedValue(e);
        }}
        className="react-select-container w-full"
        theme={SelectTheme}
      />
    </>
  );
};

export default SelectCountries;
